import React from "react";
import styles from "../styles/emissionViewContainer.module.css";
import loadingSvg from "../../Assets/images/tube-spinner.svg";

export const LoadingScreen = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div className={styles.loading}>
      <img className={styles.loadingImg} src={loadingSvg} alt="loadingSvg" />
    </div>
  );
};
